module.exports = __webpack_public_path__ + "static/mobile-footer-age-b2511458357e4b1e531bd346482682d3.jpg";